import m from "./../../../dist/es2015/locales/he_IL.js";
export const am5locales_he_IL = m;